import { Icon, List } from 'semantic-ui-react';

type Option = { id: number; label: string };

/**
 * A poll's answers and settings on the review, scheduled and sent screens — the reviewer is
 * approving the answers as much as the question. Renders nothing for any other post.
 */
export function PollPreview({ post }: { post: { options?: Option[] | null; allowMultiple?: boolean; allowOther?: boolean; closesAt?: string | null } }) {
    if (!post.options || post.options.length === 0) return null;
    return (
        <div style={{ marginBottom: '1em' }}>
            <div style={{ fontSize: '0.85em', color: 'rgba(0,0,0,.6)', marginBottom: '0.3em' }}>
                <Icon name="chart bar" /> Poll · {post.allowMultiple ? 'several answers allowed' : 'one answer each'}
                {post.allowOther ? ' · “Something else” on' : ''}
                {post.closesAt ? ` · closes ${new Date(post.closesAt).toLocaleString()}` : ''}
            </div>
            <List bulleted>
                {post.options.map((option) => <List.Item key={option.id}>{option.label}</List.Item>)}
                {post.allowOther && <List.Item><em>Something else…</em></List.Item>}
            </List>
        </div>
    );
}
